import * as actionTypes from "./ActionTypes"
// import { API } from "services/API"
import { APIGet, APIPost } from "services/APIRequest"
import UrlServer from "configs/UrlServer"
import Auth from "auth"
 
export const listsEmailHotAlertCheckUpdate = (modeName,branchName = [], quarter = []) => { 
  var userData = Auth.getUserData()
  const dataForSend = {} 

  if(userData.user_type_code != 4 && branchName.length > 0){ 
    var dealer_code = ""
    branchName.map((data,index)=>{
      if(index != 0){
        dealer_code += ","
      }
      dealer_code += data.value 
    })
    dataForSend.dealer_code = dealer_code 
    dataForSend.modeName = modeName 
  }else{
    dataForSend.modeName = modeName
    if(userData){
      dataForSend.dealer_code = userData.dealer_code
    }else{
      dataForSend.dealer_code = ""
    }    
  }
  var _quarter = []
  quarter.map((data,index)=>{
    _quarter.push(data.value)
  })
  dataForSend.quarter = JSON.stringify(_quarter)
  return dispatch => {
    APIPost(UrlServer.URL_POST_MAIL_HOT_ALERT_LIST_NOCHECK,dataForSend, datas => {
      dispatch({ type: actionTypes.LISTS_EMAIL_HOTALERT_CHECK_UPDATE, listsEmailHotAlertCheck: datas.datas })
    })
  }
}
